import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

// Connects to data-controller="ui--tooltip"
export default class extends Controller {
  static values = {
    text: String,
    position: { type: String, default: "top" },
    delay: { type: Number, default: 0 },
    offset: { type: Array, default: [0, 8] }
  }

  connect() {
    this.tippy = tippy(this.element, {
      content: this.textValue,
      placement: this.positionValue,
      delay: this.delayValue,
      offset: this.offsetValue,
      animation: false,
      aria: {
        content: "describedby"
      }
    })
  }

  disconnect() {
    this.tippy?.destroy()
  }

  textValueChanged() {
    this.tippy?.setContent(this.textValue)
  }
}
